import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilNumber } from "../../utils/utilNumber";
import { utilTime } from "../../utils/utilTime";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
export var ProfileQuickInfo = function (_a) {
    var accountSourceLocaId = _a.accountSourceLocaId, className = _a.className, xpBar = _a.xpBar, accountConnected = _a.accountConnected, onClick = _a.onClick;
    var lastLoginTime = accountConnected.lastLoginTime, amountFarmDollars = accountConnected.amountFarmDollars, amountGold = accountConnected.amountGold, name = accountConnected.name;
    return (React.createElement("div", { className: className + " flex flex--stacked flex--guts" },
        React.createElement(TextLoca, { className: IdStyles.TextNormal + " " + IdStyles.AnotherSaveDialogVMargin, id: accountSourceLocaId }),
        React.createElement("span", { className: IdStyles.TextBoldAccent + " " + IdStyles.AnotherSaveDialogVMargin + " " + IdStyles.TextWrapBreakWord }, name),
        React.createElement("span", { className: IdStyles.TextSmall + " " + IdStyles.AnotherSaveDialogVMargin }, utilTime.secondsToFullDateString(lastLoginTime)),
        React.createElement("div", { className: IdStyles.AnotherSaveDialogVMargin }, xpBar),
        React.createElement("div", { className: IdStyles.AnotherSaveDialogVMargin }),
        React.createElement("div", { className: IdStyles.AnotherSaveCurrencyContainer + " flex flex--around" },
            React.createElement("div", { className: "flex flex--aligned" },
                React.createElement(Icon, { icon: IdIcon.FarmDollarsIcn, styleId: IdStyles.IconSmall }),
                utilNumber.format(amountFarmDollars)),
            React.createElement("div", { className: "flex flex--aligned" },
                React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconSmall }),
                utilNumber.format(amountGold))),
        React.createElement("div", { className: "button-ribbon" },
            React.createElement(ButtonPrimary, { onClick: onClick },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.choose })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/ProfileQuickInfo.tsx
// module id = 2826
// module chunks = 3